// extracted by mini-css-extract-plugin
export default {"influencerlinks":"ho-z","basicPrimaryBtn":"io-z","disabled":"jo-z","basicBtn":"ko-z"};